import React, { useEffect, useState } from "react";
import api from "../api/axios";
import { Modal, Button, Spinner } from "react-bootstrap";
import DocumentViewer from "../components/modal/DocumentViewer";

function OnboardProcess() {
  const [onboards, setOnboards] = useState([]);
  const [loading, setLoading] = useState(true);

  // NEW: Document Viewer States
  const [showDocs, setShowDocs] = useState(false);
  const [docClientId, setDocClientId] = useState(null);
  const [docClientName, setDocClientName] = useState("");

  // Confirmation Modal
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [verifying, setVerifying] = useState(false);

  // Success Modal
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const token = localStorage.getItem("accessToken");

  // Fetch onboard verification list
  const fetchOnboards = async () => {
    setLoading(true);
    try {
      const res = await api.get("/onboard-verification-list", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOnboards(res.data.data || []);
    } catch (err) {
      console.error("Failed to fetch onboard verification list:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOnboards();
  }, []);

  // NEW: Open Document Viewer
  const handleViewDocuments = (clientId, clientName) => {
    setDocClientId(clientId);
    setDocClientName(clientName);
    setShowDocs(true);
  };

  // Confirm modal handlers
  const openConfirmModal = (clientId) => {
    setSelectedClientId(clientId);
    setShowConfirmModal(true);
  };

  const closeConfirmModal = () => {
    setShowConfirmModal(false);
    setSelectedClientId(null);
  };

  // Confirm verification
  const confirmVerification = async () => {
    if (!selectedClientId) return;

    setVerifying(true);
    try {
      await api.post(
        "/accounts-verification",
        {
          id: selectedClientId,
          title: "Onboarding Process Approval & Signing",
          message: "An Onboarding Process is awaiting your approval and signing",
          link: "ceo-dashboard-on-board-sign",
          comment: "Verified by account user",
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setShowConfirmModal(false);
      setSuccessMessage("✅ Client verified successfully and sent for CEO/GM approval!");
      setShowSuccessModal(true);
      fetchOnboards();
    } catch (err) {
      console.error("Verification failed:", err);
      setShowConfirmModal(false);
      setSuccessMessage("❌ Verification failed. Please try again.");
      setShowSuccessModal(true);
    } finally {
      setVerifying(false);
    }
  };

  return (
    <>
      {/* Page Title */}
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">Client Onboard Verification</h4>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Client Onboard Verification</h4>
            </div>
            <div className="card-body">
              {loading ? (
                <p>Loading...</p>
              ) : (
                <div className="table-responsive">
                  <table className="table table-bordered table-striped align-middle">
                    <thead className="table-light">
                      <tr>
                        <th>Client Name</th>
                        <th>Contact No.</th>
                        <th>Office No.</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {onboards.length > 0 ? (
                        onboards.map((item) => (
                          <tr key={item.id}>
                            <td>{item.company_name || "-"}</td>
                            <td>{item.contact_number || "-"}</td>
                            <td>{item.office ? item.office.office_no : "-"}</td>
                            <td>
                              <button
                                className="btn btn-primary btn-sm me-2"
                                onClick={() =>
                                  handleViewDocuments(item.id, item.company_name)
                                }
                              >
                                Documents
                              </button>

                              <button
                                className="btn btn-success btn-sm"
                                onClick={() => openConfirmModal(item.id)}
                              >
                                Verify
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="text-center">
                            No onboard verifications found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* NEW: Reusable Document Viewer */}
      <DocumentViewer
        clientId={docClientId}
        clientName={docClientName}
        show={showDocs}
        onClose={() => setShowDocs(false)}
      />

      {/* Confirm Verification Modal */}
      <Modal show={showConfirmModal} onHide={closeConfirmModal} centered backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Confirm Verification</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to verify this client’s onboarding?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeConfirmModal}>
            Cancel
          </Button>
          <Button variant="success" onClick={confirmVerification} disabled={verifying}>
            {verifying ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Verifying...
              </>
            ) : (
              "Yes, Verify"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Success Message Modal */}
      <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body>{successMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowSuccessModal(false)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default OnboardProcess;